import { Directive } from '@angular/core';
import { SelectComponent } from '@thiememeulenhoff/albert';
import { BaseValueAccessorDirective, valueAccessorProvider } from './base';

@Directive({
  selector:
    // eslint-disable-next-line @angular-eslint/directive-selector
    'a-select[ngModel],a-select[formControl],a-select[formControlName]',
  providers: [valueAccessorProvider(SelectValueAccessorDirective)],
})
export class SelectValueAccessorDirective extends BaseValueAccessorDirective<
  SelectComponent,
  string
> {}
